import { track } from "../track";

export const trackUploadBackgroundTry = () => track({ event: "upload_background_try" });
